module.exports = async urlTemplate => {
  if (!(window.fetch instanceof Function)) {
    return
  }
  urlTemplate = urlTemplate || process.env.CXF_PLUGINS_URL || '{game}.json'
  const cxf = await require('@goodgamestudios/cxf-ready')

  const finalUrl = template(urlTemplate, cxf)
  try {
    const response = await window.fetch(finalUrl)
    if (response.status >= 300) {
      console.error(`${response.status} ${response.statusText} - ${response.url}`)
      return
    }

    const plugins = (await response.json()) || []
    plugins.map(cxf.appendHtmlTagFor)
  } catch (error) {
    console.error('Error loading CXF plugins:', error.message, finalUrl)
  }
}

function template(tmpl, data) {
  return tmpl.replace(/{(.*?)}/, (match, placeholder) => data[placeholder])
}
